import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

function ReportContent({ report, isDrawer }) {
  const { t } = useTranslation();

  const components = {
    h1: ({ children, ...props }) => (
      <h1
        style={{
          fontSize: "1.5em",
          fontWeight: "500",
          color: "#71717a",
          margin: "0 0 10px 0",
        }}
        {...props}
      >
        {children}
      </h1>
    ),
    h2: ({ children, ...props }) => (
      <h2
        style={{
          fontSize: "1.2em",
          fontWeight: "500",
          color: "#71717a",
          margin: "0 0 10px 0",
        }}
        {...props}
      >
        {children}
      </h2>
    ),
    h3: ({ children, ...props }) => (
      <h3
        style={{
          fontSize: "1.17em",
          fontWeight: "500",
          color: "#71717a",
          margin: "0 0 10px 0",
        }}
        {...props}
      >
        {children}
      </h3>
    ),
    p: ({ children, ...props }) => (
      <p
        style={{ fontSize: "14px", fontWeight: "400", margin: "0 0 15px 0" }}
        {...props}
      >
        {children}
      </p>
    ),
    ul: ({ children, ...props }) => (
      <ul style={{ paddingLeft: "20px", marginBottom: "20px", listStyleType: "circle" }} {...props}>
        {children}
      </ul>
    ),
    li: ({ children, ...props }) => (
      <li
        style={{ fontSize: "14px", fontWeight: "400", marginBottom: "5px" }}
        {...props}
      >
        {children}
      </li>
    ),
    strong: ({ children, ...props }) => (
      <strong
        style={{ color: "#71717a", fontWeight: "500", fontSize: "14px" }}
        {...props}
      >
        {children}
      </strong>
    ),
  };

  const reportText = useMemo(() => {
    const raw = report?.report ?? '';
    return raw.replace(/\\\s*$/gm, '').replace(/\n/g, '  \n');
  }, [report]);

  return (
    <>
      <div>
        <ReactMarkdown components={components}>{reportText}</ReactMarkdown>
      </div>
      
      <div className={`${isDrawer ? "-mx-[24px]" : ""} border-t border-t-1 border-t-[#E5E7EC]`} />
      <div className={`${isDrawer ? "p-0" : "py-6"} whitespace-pre-line`}>
        <p className="text-[#71717a] font-normal text-sm">
          {t("common.comment")}{" "}
          <span className="text-black text-sm">
            {report?.comment || "N/A"}
          </span>{" "}
        </p>
      </div>
    </>
  );
}

export default ReportContent;
